import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import { environment } from '../../environments/environment';
import { CondicaoPagamento } from '../_models/CondicaoPagamento';
import moment from 'moment';

@Injectable({
    providedIn: 'root'
})

export class CondicaoPagamentoService {

    constructor(private http: HttpClient
                , private alertService: AlertService) { }

    validarWhiteList(cnpj: string): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/CondicaoPagamento/ValidarWhiteList?cnpj=${cnpj}`;
        return this.http.get<CondicaoPagamento[]>(apiURL);
    }

    ObterCondicoesPagamento(): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/CondicaoPagamento`;
        return this.http.get<CondicaoPagamento[]>(apiURL);
    }

    ObterCondicoesPagamentoAVista(): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/CondicaoPagamento/avista`;
        return this.http.get<CondicaoPagamento[]>(apiURL);
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error); // log to console instead
            console.log(`${operation} failed: ${error.message}`);

            this.alertService.error(`Ocorreu um erro ao buscar as divisões. Detalhes: \n ${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    validarCondicaoPagamento(dataEmissao: Date, dataVencimento: Date): Observable<any> {
        // tslint:disable-next-line:max-line-length
        const apiURL = `${environment.apiUrl}/api/CondicaoPagamento/Validar/${moment(dataEmissao).format('DD-MM-YYYY')}/${moment(dataVencimento).format('DD-MM-YYYY')}`;
        return this.http.get<CondicaoPagamento[]>(apiURL);
    }

    calcularPrimeiroVencimento(condicaoParcelamento: string, dataEmissao: Date): Observable<any> {
        // tslint:disable-next-line:max-line-length
        const apiURL = `${environment.apiUrl}/api/CondicaoPagamento/CalcularPrimeiroVencimento/${condicaoParcelamento}/${moment(dataEmissao).format('DD-MM-YYYY')}`;
        return this.http.get<Date>(apiURL);
    }

}
